
import '@/styles/quasar.scss'
import '@quasar/extras/mdi-v4/mdi-v4.css'
import '@quasar/extras/roboto-font/roboto-font.css'
import Notify from 'quasar/src/plugins/Notify.js';import Dialog from 'quasar/src/plugins/Dialog.js';
import iconSet from 'quasar/icon-set/mdi-v4.js'

export default {
  config: {
    notify: {
      position: 'top-right',
      timeout: 3000,
      textColor: 'white',
      progress: true
    }
  },
  plugins: {
    Notify,
    Dialog,
  },
  iconSet: iconSet
}
